//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { date } from "quasar";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import ProcessInspectorModal from "@/components/Admin/ProcessInspector/ProcessInspectorModal.vue";
import { APP_DATE_HOUR_MIN_FORMAT } from "@/assets/js/appConfig";
import { convertAndFormatTimeToLocal } from "@/assets/js/appFunc";
import AQDataTable from "@/components/Generics/AQDataTable/AQDataTable.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";

export default {
    components: {
        ProcessInspectorModal,
        AQButton,
        AQDataTable,
        AQCheckbox,
        AQTooltip,
        AQDialog,
        AQBadge,
        AQSearch
    },
    props: {
        payloadToSend: {
            type: Object,
            default: () => {}
        },
        mode: {
            type: String,
            default: "a", // a - admin(ProcessInspector), b - diagram/rule testing (RuleTesting)
            validator: v => ["a", "b"].includes(v.toLowerCase())
        },
        searchValues: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            totalPages: 0,
            applicationName: "",
            APP_DATE_HOUR_MIN_FORMAT,
            currentIndex: null,
            tableHead: null,
            isArchiving: false,
            multipleSelection: false,
            columns: [
                {
                    name: "appInfo", align: "left", field: "appInfo", visible: true
                },
                {
                    name: "startUpdate", align: "left", field: "startUpdate", visible: true
                },
                {
                    name: "status", align: "left", field: "status", visible: true
                }
            ],
            selectedInstances: [],
            canTooltip: false,
            rowsPerPageOptions: [10, 25, 50],
            canArchive: false,
            canDelete: false,
            canRetry: false,
            canTerminate: false,
            systemStatusCode: "",
            processDefId: "",
            instanceId: "",
            showProcessInformationModal: false,
            loading: false,
            headerActionDots: [
                this.$t("admin.processInspector.headerActionDots.retry"),
                this.$t("admin.processInspector.headerActionDots.terminate"),
                this.$t("admin.processInspector.headerActionDots.export"),
                this.$t("admin.processInspector.headerActionDots.archive")
                // this.$t("admin.processInspector.headerActionDots.delete")
            ],
            sortByList: [
                {
                    icon: "mdi-chevron-up",
                    label: this.$t("admin.processInspector.ascending"),
                    value: "ASC"
                },
                {
                    icon: "mdi-chevron-down",
                    label: this.$t("admin.processInspector.descending"),
                    value: "DESC"
                }
            ],
            sortStatus: [
                {
                    label: this.$t("admin.processInspector.startDate"),
                    value: "startDate"
                },
                {
                    label: this.$t("admin.processInspector.lastUpdate"),
                    value: "modifiedOn"
                },
                {
                    label: this.$t("admin.processInspector.systemStatus"),
                    value: "instanceStatus"
                }
            ],

            selected: [],
            nrOfResults: 0,
            instancesesData: [],
            resetCurrentPage: false,
            firstRander: false,
            serverPagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 10
            },
            objToSend: {
                page: 0,
                searchTerm: "",
                size: 10,
                sortDirection: "DESC",
                sortField: "modifiedOn",
                processDefinisionIds: [],
                systemStatuses: []
            },
            showConfirmDialog: false,
            dialogDetails: {},
            isArchived: false,
            searchInstance: "",
            searchResult: "",
            searchTrigger: false,
            skipQueryOnActivated: false,
            queryToSendOnPagination: {},
            activatedTriggered: false,
            requestCounter: 0,
            queryOnFirstLoad: {}
        };
    },
    computed: {
        PIModalProps() {
            return {
                processDefId: this.processDefId,
                applicationName: this.applicationName,
                selectedInstances: this.selected,
                multipleSelection: this.multipleSelection,
                isArchiving: this.isArchiving,
                isArchived: this.isArchived,
                instanceID: this.instanceId,
                objToSend: this.objToSend,
                systemStatus: this.systemStatusCode
            };
        },
        setTooltipTranslate() {
            const tooltipTranslate = {
                terminate: this.$t("admin.processInspector.headerActionDots.terminate"),
                retry: this.$t("admin.processInspector.headerActionDots.retry"),
                archive: this.$t("admin.processInspector.headerActionDots.archive"),
                export: this.$t("admin.processInspector.headerActionDots.export"),
                delete: this.$t("admin.processInspector.headerActionDots.delete"),
                canNotExport: this.$t("admin.processInspector.canNotExport"),
                canNotTerminate: this.$t("admin.processInspector.canNotTerminate"),
                canNotRetry: this.$t("admin.processInspector.canNotRetry"),
                canNotArchive: this.$t("admin.processInspector.canNotArchive"),
                canNotDelete: this.$t("admin.processInspector.canNotDelete")

            };
            return tooltipTranslate;
        },
        setTableSelection() {
            return this.instancesesData.length && this.mode === "a" ? "multiple" : "none";
        }
    },
    watch: {
        loading: {
            handler(newVal) {
                if (
                    this.mode === "a"
                    && this.tableHead
                    && this.tableHead.length
                ) {
                    if (!this.serverPagination.rowsNumber) {
                        this.tableHead[0].style.display = "none";
                    } else if (this.serverPagination.rowsNumber && newVal) {
                        this.tableHead[0].style.display = "none";
                    } else {
                        this.tableHead[0].style.display = "flex";
                    }
                }
            },
            immediate: true
        },
        payloadToSend: {
            handler(newVal) {
                if (newVal) {
                    if (newVal.searchTerm.length > 1) {
                        this.searchTrigger = true;
                        this.searchInstance = newVal.searchTerm;
                    }
                    this.applyFilter(false, false, newVal);
                    this.clearSelectedRows();
                    this.objToSend = newVal;
                }
            }
        },
        showSearch: {
            handler(newVal) {
                this.searchTrigger = newVal;
                setTimeout(() => {
                    this.searchTrigger = false;
                }, 0);
            },
            immediate: true
        }
    },
    created() {
        this.nrOfResults = 0;
        this.$root.$on("searchResult", (data) => {
            this.searchResult = data;
        });
    },
    mounted() {
        this.skipQueryOnActivated = true;
        this.tableHead = document.getElementsByTagName("thead");
        this.tableHead[0].style.display = "none";
    },
    activated() {
        this.skipQueryOnActivated = false;
        if (this.$route.query && Object.keys(this.$route.query).length) {
            this.activatedTriggered = true;
        }
    },
    destroyed() {
        this.$root.$off("searchResult");
    },
    methods: {
        convertAndFormatTimeToLocal,
        ...mapActions("documentEditor", ["generateExcel"]),
        ...mapActions("apps", ["getAllApps", "getPagedApps"]),
        ...mapActions("admin", [
            "searchProcesses",
            "retryProcess",
            "teminateInstance",
            "deleteInstances"
        ]),
        searchProcessInstances() {
            this.$emit("searchForData", this.searchInstance);
        },
        getStatus(status) {
            return status.isArchived ? "ARCHIVED" : status.systemStatus;
        },
        okConfirm() {
            this[`${this.dialogDetails.action}SelectedInstances`]();
        },
        deleteSelectedInstances() {
            this.deleteInstances(this.dialogDetails.payload.processInstanceIds).then(() => {
                this.searchProcesses(this.objToSend).then((data) => {
                    const deletedInstances = this.selected.length;
                    this.refreshTable(data);
                    this.nrOfResults -= this.selected.length;
                    this.clearSelectedRows();
                    this.selected = [];
                    this.selectedInstances = [];
                    this.$toast.showNotify({
                        type: "success",
                        message: this.$t("admin.processInspector.succesDelete", { number: deletedInstances })
                    });
                });
            });
        },
        retrySelectedInstances() {
            this.retryProcess(this.dialogDetails.payload).then(() => {
                this.searchProcesses(this.objToSend).then(data => {
                    this.refreshTable(data);
                    this.nrOfResults -= this.selected.length;
                    this.clearSelectedRows();
                    this.selected = [];
                    this.selectedInstances = [];
                    this.$toast.showNotify({
                        type: "success",
                        message: this.$t("admin.processInspector.success")
                    });
                });
            });
        },
        terminateSelectedInstances() {
            this.teminateInstance(this.dialogDetails.payload).then(() => {
                this.nrOfResults -= this.selected.length;
                this.clearSelectedRows();
                this.selected = [];
                this.selectedInstances = [];
                this.searchProcesses(this.objToSend).then(data => {
                    this.refreshTable(data);
                });
                this.$toast.showNotify({
                    type: "success",
                    message: this.$t("admin.processInspector.success")
                });
            });
        },
        clearSelectedRows() {
            this.$refs.tableProcessInsp.$refs.AQDataTable.clearSelection();
        },
        getSelectedRows(data) {
            this.selected = data;
        },
        setTooltip(action) {
            let tooltip = this.setTooltipTranslate.canNotExport;
            if (action === this.setTooltipTranslate.terminate) {
                tooltip = this.setTooltipTranslate.canNotTerminate;
            } else if (action === this.setTooltipTranslate.retry) {
                tooltip = this.setTooltipTranslate.canNotRetry;
            } else if (action === this.setTooltipTranslate.archive) {
                tooltip = this.setTooltipTranslate.canNotArchive;
            } else if (action === this.setTooltipTranslate.delete) {
                tooltip = this.setTooltipTranslate.canNotDelete;
            }
            return tooltip;
        },
        setClass(action) {
            const classItem = (!this.canTerminate && action === "Terminate")
                    || (!this.canRetry && action === "Retry")
                    || (!this.canArchive && action === "Archive")
                    || (!this.canDelete && action === "Delete")
                    || !this.selected.length ? "terminate-tooltip" : "";
            return classItem;
        },
        applyFilter(status, direction, payloadToSend) {
            if (payloadToSend) {
                this.loading = true;
                const { query } = this.$route;
                if (!this.activatedTriggered) {
                    this.resetCurrentPage = true;
                    setTimeout(() => {
                        this.resetCurrentPage = false;
                    }, 0);
                }
                if (query && Object.keys(query).length) {
                    if (query.size) {
                        payloadToSend.size = [10, 25, 50].includes(Number(query.size)) ? query.size : 10;
                    }
                    if (query.page) {
                        payloadToSend.page = query.page - 1;
                    }
                } else if (query && (!Object.keys(query).length || (Object.keys(query).length && this.activatedTriggered))
                && payloadToSend.systemStatuses && payloadToSend.systemStatuses.length > 0) {
                    if (this.queryOnFirstLoad && !Object.keys(this.queryOnFirstLoad).length) {
                        const filteredParams = {};
                        Object.entries({ ...this.objToSend }).forEach(([key, value]) => {
                            if (Array.isArray(value) && value.length > 0 && key === "systemStatuses") {
                                filteredParams[key] = value;
                            } else if (!Array.isArray(value) && value !== "" && value !== null) {
                                filteredParams[key] = value === 0 ? value + 1 : value;
                            }
                        });
                        this.queryOnFirstLoad = { ...filteredParams };
                    }
                    const { systemStatuses } = payloadToSend;
                    this.queryOnFirstLoad.systemStatuses = systemStatuses.join(",");
                    this.$router.replace({ query: this.queryOnFirstLoad });
                }

                this.searchProcesses(payloadToSend).then(data => {
                    this.instancesesData = data.data.instanceModelList;
                    this.nrOfResults = data.data.totalCount;
                    this.totalPages = data.data.totalPages;
                    this.serverPagination.rowsNumber = data.data.totalCount;
                    if (query && Object.keys(query).length && query.size) {
                        payloadToSend.size = [10, 25, 50].includes(Number(query.size)) ? query.size : 10;
                        this.serverPagination.rowsPerPage = [10, 25, 50].includes(Number(query.size)) ? query.size : 10;
                    } else if (!this.serverPagination.rowsPerPage || payloadToSend.size !== this.serverPagination.rowsPerPage) {
                        this.serverPagination.rowsPerPage = payloadToSend.size || 10;
                    }
                    if (query && Object.keys(query).length && query.page) {
                        this.serverPagination.page = query.page;
                    } else {
                        this.serverPagination.page = 1;
                    }
                    this.selected = [];
                    this.loading = false;
                    if (!data.data.totalCount && this.tableHead) {
                        this.tableHead[0].style.display = "none";
                    }
                });
            } else if (status || direction) {
                this.$emit("getObjectToSend", { status, direction, rowsPerPage: this.serverPagination.rowsPerPage });
                this.clearSelectedRows();
            }
        },
        addDropdownBorder(index) {
            let borderClass = "";
            if (index === 0) {
                borderClass = "sort-by-popover-border-top";
            } else if (index === this.sortStatus.length - 1) {
                borderClass = "sort-by-popover-border-bot";
            }
            return borderClass;
        },
        formatTimeToSend(data) {
            const dateObj = new Date(data);
            const newDate = new Date(
                dateObj.getTime() + dateObj.getTimezoneOffset() * 60 * 1000
            );
            const offset = dateObj.getTimezoneOffset() / 60;
            const hours = dateObj.getHours();
            newDate.setHours(hours + offset);
            return date.formatDate(newDate, "YYYY-MM-DD HH:mm");
        },
        showTooltip(action) {
            let isTooltip = false;
            if (this.canTooltip) {
                if (action === this.setTooltipTranslate.terminate) {
                    isTooltip = !this.canTerminate || !this.selected.length;
                } else if (action === this.setTooltipTranslate.retry) {
                    isTooltip = !this.canRetry || !this.selected.length;
                } else if (action === this.setTooltipTranslate.archive) {
                    isTooltip = !this.canArchive || !this.selected.length;
                } else if (action === this.setTooltipTranslate.export) {
                    isTooltip = !this.selected.length;
                } else if (action === this.setTooltipTranslate.delete) {
                    isTooltip = !this.canDelete || !this.selected.length;
                }
            }
            return isTooltip;
        },
        disabled(action) {
            const disable = (!this.canTerminate && action === this.setTooltipTranslate.terminate)
                || (!this.canRetry && action === this.setTooltipTranslate.retry)
                || (!this.canArchive && action === this.setTooltipTranslate.archive)
                || (!this.canDelete && action === this.setTooltipTranslate.delete)
                || !this.selected.length;
            return disable;
        },
        statusStyle(data) {
            let backgroundColor = "";
            if (data === "FAILED") {
                backgroundColor = "#D90000";
            } else if (data === "RUNNING") {
                backgroundColor = "#008FD9";
            } else if (data === "COMPLETED") {
                backgroundColor = "#14B100";
            } else if (data === "TERMINATED") {
                backgroundColor = "#000000";
            }

            return `background-color:${backgroundColor}`;
        },
        openModal({
            instanceId,
            systemStatus,
            __index,
            applicationName,
            processDefId,
            isArchived
        }) {
            if (this.mode === "a") {
                this.currentIndex = __index;
                this.instanceId = instanceId;
                this.systemStatusCode = systemStatus;
                this.showProcessInformationModal = true;
                this.applicationName = applicationName;
                this.processDefId = processDefId;
                this.isArchived = isArchived;
            } else if (this.mode === "b") {
                this.$emit("openInstance", { applicationName, instanceId });
            }
        },
        modalClosed(needsRefreshTable) {
            this.showProcessInformationModal = false;
            this.isArchiving = false;
            this.multipleSelection = false;
            if (needsRefreshTable) {
                this.searchProcesses(this.objToSend).then(data => {
                    this.refreshTable(data);
                });
            }
            this.currentIndex = null;
        },
        onHeaderMenuAction(action) {
            // popover behavior unexpected, used to force hide it
            if (!this.disabled(action)) {
                this.$refs.actionDots.hide();
            }
            if (
                action === this.setTooltipTranslate.archive
                && this.canArchive
                && this.selected.length === 1
            ) {
                this.isArchiving = true;
                this.openModal({
                    instanceId: this.selected[0].instanceId,
                    systemStatus: this.selected[0].systemStatus
                });
            } else if (
                action === this.setTooltipTranslate.archive
                && this.canArchive
                && this.selected.length > 1
            ) {
                this.multipleSelection = true;
                this.isArchiving = true;
                this.showProcessInformationModal = true;
            } else if (action === this.setTooltipTranslate.export) {
                const payloadSelected = JSON.parse(JSON.stringify(this.selected));
                const excelPayload = { sheetList: [] };
                const objPayload = {
                    headers: [],
                    sheetName: "InstancesList",
                    rows: []
                };
                for (let i = 0; i < payloadSelected.length; i++) {
                    if (i > 5000) {
                        break;
                    }
                    const instance = payloadSelected[i];
                    instance.startDate = convertAndFormatTimeToLocal(
                        instance.startDate,
                        APP_DATE_HOUR_MIN_FORMAT
                    );
                    instance.lastUpdateDate = convertAndFormatTimeToLocal(
                        instance.lastUpdateDate,
                        APP_DATE_HOUR_MIN_FORMAT
                    );
                    Object.entries(instance).forEach(([key]) => {
                        if (
                            key === "imgUrl"
                            || key === "__index"
                            || key === "processDefId"
                        ) {
                            delete instance[key];
                        }
                    });
                    objPayload.rows.push(instance);
                }

                excelPayload.sheetList.push(objPayload);
                objPayload.headers = Object.keys(payloadSelected[0]);
                this.generateExcel(excelPayload);
            }
            const payload = {
                processInstanceIds: this.selectedInstances
            };
            if (action === this.setTooltipTranslate.retry && this.selected.length && this.canRetry) {
                this.dialogDetails = {
                    confirmLabel: `${this.$t("admin.processInspector.retry")} (${this.selected.length})`,
                    cancelLabel: this.$t("generic.cancel"),
                    title: this.$t("admin.processInspector.retryNotify"),
                    message: "",
                    action: "retry",
                    payload
                };
                this.showConfirmDialog = true;
            } else if (
                action === this.setTooltipTranslate.terminate
                && this.canTerminate
                && this.selected.length
            ) {
                this.dialogDetails = {
                    confirmLabel: `${this.$t("admin.processInspector.terminateConfirm")} (${this.selected.length})`,
                    cancelLabel: this.$t("generic.cancel"),
                    title: this.$t("admin.processInspector.terminate"),
                    message: this.$t("admin.processInspector.bulkTerminateMsg"),
                    action: "terminate",
                    payload
                };
                this.showConfirmDialog = true;
            } else if (
                action === this.setTooltipTranslate.delete
                && this.canDelete
                && this.selected.length
            ) {
                this.dialogDetails = {
                    confirmLabel: this.$t("admin.processInspector.confirmDeleteInst"),
                    cancelLabel: this.$t("admin.processInspector.cancelDeleteInst"),
                    title: this.$t("admin.processInspector.deleteInstancesTitle", { number: this.selected.length }),
                    message: this.$t("admin.processInspector.deleteInstancesMess"),
                    action: "delete",
                    isDeleteAlert: true,
                    payload

                };
                this.showConfirmDialog = true;
            }
        },
        showActions() {
            this.canArchive = true;
            this.canRetry = true;
            this.canTerminate = true;
            this.canDelete = true;
            let terminateBreak = false;
            let retryBreak = false;
            let archiveBreak = false;
            let deleteBreak = false;
            this.canTooltip = true;
            this.selectedInstances = [];
            if (this.selected.length) {
                for (let i = 0; i < this.selected.length; i++) {
                    if (!retryBreak && this.selected[i].systemStatus !== "FAILED") {
                        this.canRetry = false;
                        retryBreak = true;
                    }
                    if (!terminateBreak && (["TERMINATED", "COMPLETED"].includes(this.selected[i].systemStatus)
                    || this.selected[i].rootProcessInstanceId !== this.selected[i].instanceId)) {
                        this.canTerminate = false;
                        terminateBreak = true;
                    }
                    if (!archiveBreak && (this.selected[i].isArchived || ["RUNNING", "FAILED"].includes(this.selected[i].systemStatus)
                    || this.selected[i].rootProcessInstanceId !== this.selected[i].instanceId)) {
                        this.canArchive = false;
                        archiveBreak = true;
                    }
                    if (!deleteBreak && (["RUNNING", "FAILED"].includes(this.selected[i].systemStatus)
                    || this.selected[i].rootProcessInstanceId !== this.selected[i].instanceId)) {
                        this.canDelete = false;
                        deleteBreak = true;
                    }
                    this.selectedInstances.push(this.selected[i].instanceId);
                }
            }
        },
        request(pagination) {
            this.requestCounter++;
            if (this.requestCounter >= 2) {
                this.activatedTriggered = false;
            }
            if (this.activatedTriggered) {
                return;
            }

            this.loading = true;
            const { query } = this.$route;
            if (query && Object.keys(query).length) {
                this.queryToSendOnPagination = { ...query };
                if (!this.skipQueryOnActivated || (query.size && ![10, 25, 50].includes(Number(query.size)))) {
                    this.queryToSendOnPagination.size = [10, 25, 50].includes(Number(query.size)) ? pagination.rowsPerPage : 10;
                    this.queryToSendOnPagination.page = pagination.page;
                    if (query.page !== pagination.page || query.size !== pagination.rowsPerPage) {
                        const normalizeQuery = queryObj => Object.fromEntries(
                            Object.entries(queryObj).map(([key, value]) => [key, String(value)])
                        );
                        const queriesAreDifferent = JSON.stringify(normalizeQuery(this.queryToSendOnPagination))
                        !== JSON.stringify(normalizeQuery(this.$route.query));

                        if (queriesAreDifferent) {
                            this.$router.replace({ query: this.queryToSendOnPagination });
                        }
                    }
                }
            } else {
                const filteredParams = {};
                Object.entries({ ...this.objToSend }).forEach(([key, value]) => {
                    if (Array.isArray(value) && value.length > 0) {
                        filteredParams[key] = value;
                    } else if (!Array.isArray(value) && value !== "" && value !== null) {
                        filteredParams[key] = value;
                    }
                });
                filteredParams.size = pagination.rowsPerPage;
                filteredParams.page = pagination.page;
                this.queryOnFirstLoad = { ...filteredParams };
            }
            if (!this.skipQueryOnActivated) {
                this.objToSend.page = pagination.page - 1;
                this.objToSend.size = pagination.rowsPerPage;
            } else {
                this.objToSend.page = query && Object.keys(query).length && query.page ? query.page - 1 : pagination.page - 1;
                if (query && Object.keys(query).length && query.size) {
                    this.objToSend.size = [10, 25, 50].includes(Number(query.size)) ? query.size : 10;
                } else {
                    this.objToSend.size = pagination.rowsPerPage;
                }
            }

            this.searchProcesses(this.objToSend).then(data => {
                this.instancesesData = data.data.instanceModelList;
                this.nrOfResults = data.data.totalCount;
                this.totalPages = data.data.totalPages;
                this.serverPagination.rowsNumber = data.data.totalCount;
                this.loading = false;
            });
            if (!this.skipQueryOnActivated) {
                this.serverPagination.rowsPerPage = pagination.rowsPerPage;
                this.serverPagination.page = pagination.page;
            } else {
                if (query && Object.keys(query).length && query.size) {
                    this.serverPagination.rowsPerPage = [10, 25, 50].includes(Number(query.size)) ? query.size : 10;
                } else {
                    this.serverPagination.rowsPerPage = pagination.rowsPerPage;
                }
                this.serverPagination.page = query && Object.keys(query).length && query.page ? query.page : pagination.page;
            }
            this.skipQueryOnActivated = false;
        },
        refreshInstances() {
            const pagination = {
                descending: false,
                page: 1,
                rowsPerPage: 10,
                sortBy: null
            };
            document.getElementById("refresh").classList.remove("q-focusable");
            this.clearSelectedRows();
            this.selected = [];
            this.request(pagination);
        },
        refreshTable(data) {
            this.instancesesData = data.data.instanceModelList;
            this.nrOfResults = data.data.totalCount;
            this.totalPages = data.data.totalPages;
            this.serverPagination.rowsNumber = data.data.totalCount;
            if (this.serverPagination.page !== 1) {
                const pagination = {
                    descending: false,
                    page: 1,
                    rowsNumber: data.data.totalCount,
                    rowsPerPage: 10,
                    sortBy: null
                };
                this.request(pagination);
            }
            this.selected = [];
        }
    }
};
